// extracted by mini-css-extract-plugin
module.exports = {"link":"_1fPR9","root":"UaEf2","label":"pWNha"};